import * as core from '../../../../../../../core'

import { query } from './key-benefits-by-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'key.benefits.by.workstream',
    description: 'Chart view of key benefits by workstream',
    name: 'Key Benefits by Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
